import React, { FC } from 'react';
import { LibraryBooks } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { getSelectedText } from '../../tiptapHelper';
import { useGuideCmsContext } from '../../../GuideCmsContext';

export const AddGuideLinkToolbarButton: FC<{ guideId: string }> = ({ guideId }) => {
  const { openGuideLinkDialog } = useGuideCmsContext();
  const editor = useRichTextEditorContext();
  const handleOnClick = async () => {
    if (!editor) return;
    await openGuideLinkDialog(getSelectedText(editor));
  };
  if (!editor) return null;
  return (
    <MenuButton disabled={!editor?.isEditable} IconComponent={LibraryBooks} tooltipLabel="Lenke til anvisning" onClick={handleOnClick}></MenuButton>
  );
};
